import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { filter, first, map, toArray } from "rxjs/operators";
import { TemplateFacade } from "src/app/services/template.facade";
import { StepFacade } from "src/app/step/services/step.facade";
import { IStepTypeProviderDescription } from "../../interfaces";
import { LogClass, Logger, LogMethod } from "../../logger";
import { NavigationService } from "../../services/navigation.service";

@Component({
    selector: "circ-new-step-template",
    templateUrl: "./new-step.component.html",
    styleUrls: ["./new-step.component.scss"],
    standalone: false
})
@LogClass({ source: "Template/NewStepComponent" })
export class NewStepComponent implements OnInit {
  public providers$: Observable<IStepTypeProviderDescription[]>;
  public selectedProvider: IStepTypeProviderDescription = null;

  private logger: Logger;

  constructor(
    private navigate: NavigationService,
    private stepFacade: StepFacade,
    private templateFacade: TemplateFacade
  ) {}

  public abort(): void {
    this.navigateToCurrentTemplate();
  }
  private navigateToCurrentTemplate(): void {
    this.templateFacade
      .getTemplateId()
      .pipe(
        filter((t) => !!t),
        first()
      )
      .subscribe((id) => this.navigate.toTemplate(id));
  }

  @LogMethod()
  public ngOnInit(): void {
    this.providers$ = this.stepFacade.getTypes().pipe(toArray());

    this.providers$
      .pipe(
        filter((p) => !!p && p.length > 0),
        map((p) => p[1]),
        first()
      )
      .subscribe((p) => (this.selectedProvider = p));
  }
}
